import api from './api'

export interface ErrorReport {
  id: string
  errorMessage: string
  endpoint: string | null
  userId: string | null
  userEmail: string | null
  userName: string | null
  companyId: string | null
  companyName: string | null
  companyType: string | null
  status: string | null
  resolvedAt: string | null
  resolvedBy: string | null
  createdAt: string
}

export interface ErrorReportDetail extends ErrorReport {
  errorDetails: string | null
  errorCode: string | null
  stackTrace: string | null
  page: string | null
  action: string | null
  userAgent: string | null
  url: string | null
  additionalInfo: Record<string, unknown> | null
  retryResult: Record<string, unknown> | null
}

export interface ErrorReportStats {
  total: number
  pending: number
  resolved: number
  retried: number
  today: number
}

export interface ErrorReportListResponse {
  errors: ErrorReport[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
  stats: ErrorReportStats
}

export interface ErrorReportFilters {
  page?: number
  limit?: number
  status?: string
  endpoint?: string
  search?: string
  date_from?: string
  date_to?: string
}

export async function listErrorReports(filters?: ErrorReportFilters): Promise<ErrorReportListResponse> {
  const params = new URLSearchParams()
  if (filters?.page) params.append('page', String(filters.page))
  if (filters?.limit) params.append('limit', String(filters.limit))
  if (filters?.status) params.append('status', filters.status)
  if (filters?.endpoint) params.append('endpoint', filters.endpoint)
  if (filters?.search) params.append('search', filters.search)
  if (filters?.date_from) params.append('date_from', filters.date_from)
  if (filters?.date_to) params.append('date_to', filters.date_to)

  const queryString = params.toString()
  const response = await api.get(`/master/errors${queryString ? `?${queryString}` : ''}`)
  return response.data
}

export async function getErrorReport(id: string): Promise<ErrorReportDetail> {
  const response = await api.get(`/master/errors/${id}`)
  return response.data.error
}

export async function retryError(id: string): Promise<{ message: string; result: Record<string, unknown> }> {
  const response = await api.post(`/master/errors/${id}/retry`)
  return response.data
}

export async function resolveError(id: string): Promise<{ message: string }> {
  const response = await api.put(`/master/errors/${id}/resolve`)
  return response.data
}
